import React, { useState, useRef, useEffect, useCallback } from "react";
import {firestore, timestamp} from './firebaseConfig';
import { ResponsiveContainer, PieChart, Pie, Sector,Cell } from "recharts";
import { useSessionReactions } from './reusableHooks';
import 'bootstrap/dist/css/bootstrap.css'; 

const useLiveData = (sessionId, millis) => {
  const [data,setData] = useState([]);
  const mountedRef = useRef(false);

  useEffect(() => {
      mountedRef.current = true;
      const unsubscribe = firestore
          .collection("meetings/" + sessionId + "/votes").where("timestamp", ">=", millis).orderBy("timestamp").orderBy("reaction")
          .onSnapshot((snapshot) => {
              const counts = {};
              const newData = [];
              snapshot.docs.map((doc, index) => {
                  if(counts[snapshot.docs[index].data().reaction]) {counts[snapshot.docs[index].data().reaction]++; }
                  else {counts[snapshot.docs[index].data().reaction] = 1;}
              })

              for(const reaction in counts) {
                  newData.push({
                      name: reaction,
                      value: counts[reaction]
                  })
              }
              if(mountedRef.current) setData(newData);
          })
      return () => {
          mountedRef.current = false; 
          unsubscribe();
      };        
  }, [sessionId, millis]) 

  return data;
}

const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';
  
    return (
      <g>
        <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill} fontSize="1.1rem">
          {payload.name}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
        <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
        <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333" fontSize="0.9rem">{`${value} People`}</text>
        <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999" fontSize="0.9rem">
          {`(${(percent * 100).toFixed(2)}%)`}
        </text>
      </g>
    );
  };


const barColors = ["#E41A1C", "#FF7F00", "#377EB8", "#984EA3", "#4DAF4A", "#404142"];
const COLORS = {};

export default function Piechart({sessionId, setTrendingReaction, meetingEnded}) {
  
  const LAST_MINUTE = () => (timestamp.fromMillis((timestamp.now().seconds*1000)-60000));
  const [interval, setNewInterval] = useState(LAST_MINUTE());
  const data = useLiveData(sessionId, interval);
  const mountedRef = useRef(false);

  const participantTags = useSessionReactions(sessionId, false);
  participantTags?.map((reaction, index) => {
    COLORS[reaction] = barColors[index % barColors.length];
  })
  const [entries, setEntries] = useState([]);

  const [activeIndex, setActiveIndex] = useState(null);

  const onMouseOver = useCallback((data, index) => {
    setActiveIndex(index);
  }, []);
  const onMouseLeave = useCallback(() => {
    setActiveIndex(null);
  }, []);

  //refreshes component every 60 seconds
  useEffect(() => {
    mountedRef.current = true;

    const timer = setInterval(() => {
        if(mountedRef.current) setNewInterval(LAST_MINUTE());
      return () => clearInterval(timer)
    }, 60000);

    return () => { mountedRef.current = false; };
  },[])

  useEffect(() => {
    const counts = {};
    const max = {reaction : "", count: 0};

    if(participantTags.length > 0 && data.length > 0 && mountedRef.current && meetingEnded === false){

      participantTags?.map((entry) => {
        counts[entry] = 0;
      })

      data?.map((entry) => {
        counts[entry.name] = entry.value;
        if(entry.value > max.count) {
          max.reaction = entry.name;
          max.count = entry.value;
        }
      })
      setTrendingReaction(max.reaction);
      setEntries(Object.entries(counts));
    }
    else if(data.length === 0 && mountedRef.current && meetingEnded === false) {
      setTrendingReaction("None");
    }
  },[data, meetingEnded]);

  return (
    <>
    {/*<div className="d-none" style={{paddingLeft: "6rem", paddingRight: "6rem"}}>
    <ResponsiveContainer width="100%" height={100} className="sentiment-chart">
      <PieChart height="100%" width="100%">
        <Pie
          activeIndex={activeIndex}
          isAnimationActive={true}
          data={data}
          dataKey="value"
          nameKey="name"
          innerRadius={45}
          outerRadius={65}
          fill="#8884d8"
          activeShape={renderActiveShape}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
        >
        {data.map((entry, index) => (      
          <Cell key={`cell-${index}`} fill={COLORS[entry.name]} />
        ))
        }
        </Pie>
      </PieChart>
    </ResponsiveContainer>
    </div>
    <div className="sentiment-legend pl-4">
      <div className="grid-container">
        {entries.map((entry, index) => {
          return <><div className={"grid-item name position-relative"} style={{color: COLORS[entry[0]]}}><h6>{entry[0]}</h6></div>
          <div className="grid-item"><h6 className="text-right">{entry[1]}</h6></div></>
        })}
        
      </div>
      </div>*/}
    </>
  );
}
